module.exports = __webpack_public_path__ + "img/weird-history.f5bbdf2.jpg";